// This file is auto-generated by @hey-api/openapi-ts

export const TicketCombinationTypesEnum = { SINGLE: 'SINGLE', TIME: 'TIME' } as const;

export type TicketCombinationTypesEnum = typeof TicketCombinationTypesEnum[keyof typeof TicketCombinationTypesEnum];
